module.exports = __webpack_public_path__ + "assets/img/home-main-content-bg2.4eb59cb1.png";